import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

const VideoExplainIcon = (props) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#a)" fill="#48A9C2">
      <Path d="M21.413 6.667H2.587A1.253 1.253 0 0 0 1.333 7.92v12.16a1.254 1.254 0 0 0 1.254 1.253h18.826a1.254 1.254 0 0 0 1.254-1.253V7.92a1.254 1.254 0 0 0-1.254-1.253ZM21.333 20H2.667V8h18.666v12ZM20.093 2a.667.667 0 0 0-.666-.667H4.76A.667.667 0 0 0 4.093 2v.667h16V2ZM21.413 4.667A.667.667 0 0 0 20.747 4H3.413a.667.667 0 0 0-.666.667v.666h18.666v-.666Z" />
      <Path d="M8.547 17.86a1.121 1.121 0 0 0 1.08.087l6.513-2.907a1.127 1.127 0 0 0 0-2.066l-6.513-2.907A1.133 1.133 0 0 0 8.033 11.1v5.813a1.134 1.134 0 0 0 .514.947Zm.42-6.76a.193.193 0 0 1 .093-.166.2.2 0 0 1 .107 0 .18.18 0 0 1 .08 0l6.513 2.9a.193.193 0 0 1 .12.186.187.187 0 0 1-.12.18l-6.513 2.907a.186.186 0 0 1-.187 0 .207.207 0 0 1-.093-.167V11.1Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);

export default VideoExplainIcon;
